import styled, { css } from 'styled-components';
import { Scalars } from '@bechtel/types';
import { Heading, Avatar } from '@bechtel/gds';
import { SearchField } from '@bechtel/client-common';
import { Box, Button, IconStyled, TextFieldStyled, inputSmallStyles, Icon } from '@bechtel/gds';

export const StyledIcon = styled(Icon)`
  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      & > svg {
        height: ${theme.fontSizes[500]};
      }
    }
  `}
`;

export const SearchFieldStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  flexGrow: { sm: 1 },
})`
  width: 28%;
  margin-right: ${({ theme }) => theme.spacings[400]};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: 22%;
  }
  ${IconStyled} {
    right: ${({ theme }) => theme.spacings[500]};
  }
  ${TextFieldStyled} {
    ${({ theme }) => css`
      font-size: ${theme.fontSizes[400]};
      border-color: ${theme.colors.grey[300]};
      font-family: 'Graphik';
    `}
  }
`;

export const SearchFieldComponentStyled = styled(SearchField)`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputSmallStyles}
  }
`;

interface SearchFilterButtonStyledProps {
  isDefaultChange: Scalars['Boolean'];
}
export const SearchFilterButtonStyled = styled(Button)<SearchFilterButtonStyledProps>`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputSmallStyles}
  }
  ${(props) =>
    props.isDefaultChange &&
    css`
      background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      &:hover {
        background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      }
    `}
`;

export interface MapMarkerButtonProps {
  isActive: boolean;
}

export const MapMarkerButtonStyled = styled(Button)<MapMarkerButtonProps>`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputSmallStyles}
  }
  ${({ theme, isActive }) => css`
    background-color: ${isActive ? theme.colors.bechtel.blue[700] : theme.colors.white};
    &:hover {
      background: ${isActive ? theme.colors.bechtel.blue[700] : theme.colors.white};
    }
  `}
`;

export const HeadingStyled = styled(Heading).attrs({
  size: '400',
  color: 'grey.1000',
})`
  padding-top: ${({ theme }) => theme.spacings[100]};
  padding-bottom: ${({ theme }) => theme.spacings[100]};
  white-space: nowrap;
`;

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
  `}
`;

export const DrawerContainerStyled = styled(Box)`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${({ theme }) => css`
      border-radius: ${theme.spacings[400]};
      background-color: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      bottom: 0;
    `}
  }
`;
